import notificationTypes from 'plugins/i18n/notificationTypes.de.ts'

export default {
	notifications: {
		markAllAsRead: 'Alle als gelesen markieren',
		loaded: 'geladen',
		noInformationAvailable: 'Keine Information verfügbar',
		noneFound: 'Es liegen keine {status} Benachrichtigungen vor',
		new: 'neuen',
		sentOn: 'Verschickt am',
		unread: 'Ungelesene',
		read: 'Gelesene',
		all: 'Alle',
		show_notification: 'Benachrichtigung anzeigen',
		notification_already_read: 'Benachrichtigung bereits gelesen',
		mark_as_read: 'Als gelesen markieren',
		read_notifications: 'gelesenen',
		sender: '@:common.sender',
		notificationTypes: notificationTypes,
	},
}
